export default "__VITE_ASSET__6f581c93__"